import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, styled, } from "@mui/material";
const StyledDialog = styled(Dialog)({
    "& .MuiDialog-paper": {
        borderRadius: "10px",
        padding: "45px 60px",
    },
});
const StyledDialogTitle = styled(DialogTitle)({
    fontSize: "1.8rem",
    color: "rgba(0, 0, 0, 0.8)",
    textAlign: "start",
    marginBottom: "15px",
    padding: 0,
});
const Note = styled(DialogContentText)({
    marginTop: "10px",
});
const StyledDialogActions = styled(DialogActions)({
    margin: 0,
    padding: 0,
});
/** Dialog used for confirming a choice. Has a Yes and No button */
export const ConfirmDialog = ({ description, onCancel, onConfirm, open, title, note, dialogChildren, }) => {
    return (_jsxs(StyledDialog, { open: open, onClose: onCancel, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [_jsx(StyledDialogTitle, { id: "alert-dialog-title", children: title }), _jsxs(DialogContent, { style: { paddingLeft: 0, paddingRight: 0 }, children: [_jsx(DialogContentText, { id: "alert-dialog-description", children: description }), note && (_jsxs(Note, { children: [_jsx("strong", { children: "Note:" }), " ", note] })), dialogChildren] }), _jsxs(StyledDialogActions, { sx: { display: "flex", justifyContent: "space-between" }, children: [_jsx(Button, { variant: "outlined", color: "secondary", onClick: onCancel, children: "No" }), _jsx(Button, { variant: "contained", onClick: onConfirm, children: "Yes" })] })] }));
};
